import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import Congrats from '../Assets/Image/Animation - 1741589111855.gif';
import '../Assets/Css/congratulationCard.css';

const OrderConfirmationPage = () => {
    const navigate = useNavigate();

    return (
        <div  className="d-flex justify-content-center align-items-center vh-100" style={{backgroundColor:'#E1F1E2'}}>
            <Row className="w-100">
                <Col className="d-flex justify-content-center">
                    <Card 
                        className="congratulation-card rounded bg-white shadow-lg d-flex justify-content-center align-items-center"
                    >
                        <Card.Body className="text-center">
                            {/* Displaying GIF */}
                            <img
                                className="confirmation-img mb-3"
                                src={Congrats}
                                alt="Donation Successful"
                            />
                            <Card.Title className="mb-3" style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
                                Thank You for Your Generous Donation!
                            </Card.Title>
                            <Card.Text className="mb-2">
                                Your donation has been successfully received.
                            </Card.Text>
                            <Card.Text className="mb-4">
                                We deeply appreciate your support. Your contribution helps us continue our mission and make a real difference.
                            </Card.Text>
                            <Button
                                size="sm"
                                style={{
                                    backgroundColor:'#66b94c',
                                    color:'white',
                                    border:'none',
                                    padding: '7px 8px',
                                    fontSize: '14px',
                                    borderRadius: '4px',
                                    width:'200px'
                                }}
                                onClick={() => navigate('/')}
                            >
                                Back to Home
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default OrderConfirmationPage;
